import type { AgentSkill } from "@common/schemas/domains/agentSkills/agent-skill.schema";
import { useAgentSkillRevisions } from "@api/agentSkill.api";
import { AgentSkillRevisionList } from "./AgentSkillRevisionList";
import type { useAgentSkillLifecycle } from "./useAgentSkillLifecycle";

interface Props {
    skill: AgentSkill;
    canManage: boolean;
    restore: ReturnType<typeof useAgentSkillLifecycle>["restore"];
    onMoved: (skillId: string) => void;
}

export const AgentSkillVersionsTab = ({
    skill,
    canManage,
    restore,
    onMoved,
}: Props) => {
    const { data: revisions = [], isFetched } = useAgentSkillRevisions(
        skill.id,
    );
    return (
        <AgentSkillRevisionList
            revisions={revisions}
            isFetched={isFetched}
            currentRevisionId={skill.currentRevisionId}
            canManage={canManage}
            onRestore={async (revision) => {
                const restored = await restore({
                    skillId: skill.id,
                    revisionId: revision.id,
                    version: revision.version,
                });
                if (restored && restored.id !== skill.id) {
                    onMoved(restored.id);
                }
                return restored;
            }}
        />
    );
};
